import styled, { css } from 'styled-components';
import { FontSizes } from '../typography/typography.styles';
import { BREAKPOINTS } from '../../constants/breakpoints';

interface CollapsableContentProps {
  $isOpen?: boolean;
}

export const CollapsableContainerWrapper = styled.div<CollapsableContentProps>`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey25};
  border-radius: 1rem;
  padding: 1.6rem 1.6rem 1.6rem 1.6rem;

  @media (max-width: ${BREAKPOINTS.mobile.css}) {
    border: none;
    padding: 0;
    border-radius: 0;
    ${({ $isOpen }) =>
      $isOpen
        ? css`
            border-bottom: 1px solid
              ${({ theme }) => theme.colors.baseColors.grey25};
            padding-bottom: 1.2rem;
          `
        : css``}
  }
`;

export const CollapsableContainerTitle = styled.button<CollapsableContentProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;

  font-size: ${FontSizes.medium};
  font-weight: 500;
  line-height: 2.2rem;
  letter-spacing: 0.5px;

  @media (max-width: ${BREAKPOINTS.mobile.css}) {
    border: 1px solid ${({ theme }) => theme.colors.baseColors.grey25};
    border-radius: 1rem;
    padding: 1.6rem 1.6rem 1.6rem 1.6rem;
  }

  svg {
    flex-shrink: 0;
    transition: transform 0.25s ease;

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const CollapsableContent = styled.div<CollapsableContentProps>`
  display: grid;
  grid-template-rows: 0fr;
  transition:
    grid-template-rows 0.25s ease,
    opacity 0.25s ease,
    margin-top 0.25s ease;
  opacity: 0;
  margin-top: 0;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      grid-template-rows: 1fr;
      opacity: 1;
      margin-top: 1.6rem;

      @media (max-width: ${BREAKPOINTS.mobile.css}) {
        margin-top: 1.2rem;
      }
    `}
`;

export const CollapsableContentInner = styled.div`
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;
